import { addError } from './../errors/actions'
import { setRepoFlatSchema } from './reducer'
import { setLoading } from './../loading/reducer'
import getUsersBranches from './../../data/getUsersBranches'
import { addBranch } from './../branches/actions'
import createRepository from './../../data/createRepository'
import { addRepository } from './actions'
import { addFile } from './../files/actions'
import commitFiles from './../../data/commitFiles'
import getSchema from './../../data/getSchema'

export default ({ dispatch, getState }) => next => async action => {

  if (action.type === 'LOAD_BRANCHES'){
    var repoId = action.payload.repoId
    if (`${repoId}-branches` in getState().loading) return
    // Is already loading
    //if (getState().loading[repoId]) return
    dispatch(setLoading(`${repoId}-branches`, true))
    try {
      var branches = await getUsersBranches(getState().token, repoId)
    } catch (err){
      if (err.code)
        dispatch(addError(err))
      throw err
    } finally {
      dispatch(setLoading(`${repoId}-branches`, false))
    }
    dispatch(branches.map(branch => addBranch(branch)))
  }

  if (action.type === 'CREATE_REPOSITORY'){
    const { newRepositoryName, ownerId } = action.payload
    if (`creating-branch-${ownerId}` in getState().loading) return
    dispatch(setLoading(`creating-branch-${ownerId}`, true))

    try {
      var newRepo = await createRepository(getState().token, newRepositoryName, ownerId)
      var branches = await getUsersBranches(getState().token, newRepo.id)
      // Assume there's one branch (the master)
      var tempSchemaFile = { path: 'src/schema.js', text: sampleSchemaFileContent }
      await commitFiles(
        getState().token, branches[0].id, [ tempSchemaFile ], 'Adding initial schema file.')
      var schemaFile = await getSchema(getState().token, branches[0].id)
      dispatch([
        addRepository(newRepo),
        ...(branches.map(b => addBranch(b))),
        addFile(schemaFile, branches[0].id),
      ])
    } catch (err) {
      if (err.code)
        dispatch(addError(err))
      throw err
    } finally {
      dispatch(setLoading(`creating-branch-${ownerId}`, false))
    }
  }

  return next(action)
}

const sampleSchemaFileContent = `{
  "schemaVersion": 5,
  "layout": [
    {
      "type": "page",
      "name": "Customer Details",
      "layout": [
        {
          "type": "form",
          "layout": [
            {
              "type": "text",
              "text": " ",
              "header": "What is your email address?"
            },
            {
              "text": " ",
              "type": "list",
              "header": "What is your title?",
              "values": [
                "Mr",
                "Mrs",
                "Miss"
              ]
            },
            {
              "text": " ",
              "type": "text",
              "header": "First name"
            },
            {
              "text": " ",
              "type": "text",
              "header": "Last name"
            },
            {
              "text": " ",
              "type": "date",
              "header": "What is your date of birth?"
            },
            {
              "text": " ",
              "type": "text",
              "header": "Mobile number"
            }
          ]
        }
      ]
    },
    {
      "name": "Address",
      "type": "page",
      "layout": [
        {
          "type": "form",
          "layout": [
            {
              "type": "text",
              "text": " ",
              "header": "What is the first line of your address?"
            },
            {
              "text": " ",
              "type": "text",
              "header": "What is the second line of your address?"
            }
          ]
        }
      ]
    }
  ]
}`


// WEBPACK FOOTER //
// ./src/store/repositories/middleware.js